export const EVENTS_NAMES = {
  PATH_STARTED: 'Path Started',
  PATH_STOPPED: 'Path Stopped',
  PROGRAM_MODIFIED: 'Path Stopped', // As requested by our product manager, this event name is the same as the previous one
};